import React from "react";
// import headerBackgroundImage from "./card-background-2.png";

function LandmarkEvent() {
  return (
    // <div className='' style={{ backgroundImage: `url(${headerBackgroundImage})` }}>
    <div className="py-8">
      {/* <div>
                <img className='w-full' src='newimage/banner/aboutBrother.svg'></img>
            </div> */}
      <div>
        {/* <div className="p-2 mx-[28%] items-center flex-col justify-center font-serif text-center text-blue-800 text-2xl bg-[aliceblue] rounded-full">
          <div className="h-[2px] my-auto mx-2 w-20 bg-blue-800 inline-block"></div>
          OUR GLOBAL MISSION
          <div className="h-[2px] my-auto w-20 bg-blue-800 inline-block mx-2"></div>
        </div> */}
         <h2 className="border-b-2 border-[gainsboro] w-[28%] mx-auto items-center flex-col justify-center font-serif text-center text-blue-800 text-[26px] uppercase rounded-2xl">
         Landmark  Event      </h2>
        <div className="grid gap-6 px-10 pt-10 xs:grid-cols-1 md:grid-cols-2">
          <div className="col-span-1 ">
            <img
              src="image/home/LandmarkEvents.jpg"
              className=" w-[100%]  mx-auto rounded-2xl"
            ></img>
          </div>
          <div className="col-span-1">
            {/* <h1 className="pb-1 font-medium xs:text-xl md:text-xl xs:pt-4">
              {" "}
              Our Ideology
            </h1> */}
            {/* <div className="border-b-2 border-blue-800 w-36"></div> */}
            <p className="font-serif text-justify overflow-y-scroll h-[500px] text-[18px]">
              Over the last 90 years of its journey, the Sant Nirankari Mission
              has become a synonym of Oneness, love, peace, tolerance, selfless
              service and compassion. Though these virtues are frequently quoted
              by many, the Mission helps achieve them in our life through
              Practical Spirituality. It has been distinctly mentioned in
              various spiritual realms that knowing the Universal Truth is an
              infallible remedy to reduce stress, illusion, fear and ego; and
              that knowing this truth does not require a tedious journey, rather
              a mere seeking from the core of our consciousness. This pure quest
              for bliss becomes a catalyst to receive guidance and grace of the
              Satguru (The True Master) in the form of Brahmgyan (God-Knowledge)
              in no time. Millions of Nirankari devotees are a living testimony
              to the transformation that their life has experienced after
              receiving the spiritual bliss and awareness from Satguru. The
              Mission has also been instrumental in social upliftment in
              numerous ways, without any prejudice, living up to its basic ethos
              of One World-One Family. The Sant Nirankari Mission started
              spreading the message of Love and Brotherhood across the world
              with the efforts and vision of Shahenshah Baba Avtar Singh Ji.
              This vision was taken forward by Baba Gurbachan Singh Ji, along
              with Nirankari Rajmata Ji, with branches of the Mission being
              setup in UK, US, Canada, Middle East, Australia and other parts of
              the world. The baton of Truth was taken ahead with even more
              momentum by Baba Hardev Singh Ji and Mata Savinder Ji, who
              embraced the world with their compassion and care. The Mission
              spread to more than 3000 branches in India and many hundreds in
              over 70 countries across the world. Many social initiatives have
              been taken in the last many decades in these centres including
              Blood Donation Camps, Food Drives, Social Awareness Programs,
              Cleanliness Drives, Tree Plantation Drives, Help and Support
              during Natural Calamities etc. These contributions have been
              acknowledged and honoured with numerous awards and recognitions
              over the years. The Mission has also been granted the general
              consultative status by the United Nations Organization. Welcome to
              the family of God-realised souls.{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandmarkEvent;
